export const PUSH_MESSAGE_RECEIVED = 'PUSH_MESSAGE_RECEIVED';
export const PUSH_MESSAGE_VIEWED = 'PUSH_MESSAGE_VIEWED';
